<template>
  <div class="seasidetms_woo_wrap_result">
    <!--<p class="woocommerce-result-count">
      Отображение 1–12 из 148
    </p>-->
    <form class="woocommerce-ordering" @submit.prevent>
      <select name="orderby" class="orderby">
        <option value="">{{ $t('sort.default') }}</option>
        <option value="price_asc">{{ $t('sort.price_asc') }}</option>
        <option value="price_desc">{{ $t('sort.price_desc') }}</option>
        <!-- <option value="sale">{{ $t('sort.sale') }}</option> -->
      </select>
      <div class="sort-wrapper">
        <div class="select-selected" @click.stop.prevent="onToggleSelect">
          {{ sortDisplayValue() }}
          <span id="sortarrow" :class="sortItemsOpened ? ' active' : ''"></span>
        </div>
        <div class="viewmode">
          <div>
            <a
              href="#"
              @click.stop.prevent="onSetViewMode(true)"
              :class="`viewmode-icon icon-grid${
                categoryViewMode ? ' active' : ''
              }`"
              >&nbsp;</a
            >
            <a
              href="#"
              @click.stop.prevent="onSetViewMode(false)"
              :class="`viewmode-icon icon-list${
                categoryViewMode ? '' : ' active'
              }`"
              >&nbsp;</a
            >
          </div>
        </div>
        <div class="perpage">
          {{ $t('show') }}:
          <a
            href="#"
            @click.stop.prevent="onSetPerpage(12)"
            :class="{ active: perPage === 12 }"
          >
            <span>12</span>
          </a>
          <a
            href="#"
            @click.stop.prevent="onSetPerpage(24)"
            :class="{ active: perPage === 24 }"
          >
            <span>24</span>
          </a>
          <a
            href="#"
            @click.stop.prevent="onSetPerpage(36)"
            :class="{ active: perPage === 36 }"
          >
            <span>36</span>
          </a>
        </div>
      </div>
      <div :class="`select-items${sortItemsOpened ? '' : ' select-hide'}`">
        <div @click.stop.prevent="onSelect('')">
          {{ $t('sort.default') }}
        </div>
        <div @click.stop.prevent="onSelect('price_asc')">
          {{ $t('sort.price_asc') }}
        </div>
        <div @click.stop.prevent="onSelect('price_desc')">
          {{ $t('sort.price_desc') }}
        </div>
        <!-- <div @click.stop.prevent="onSelect('sale')">
          {{ $t('sort.sale') }}
        </div> -->
      </div>
    </form>
    <button class="btn-filter" @click="onOpenMobileFilters">
      {{ filtersMobile ? $t('closeFilter') : $t('openFilter') }}
    </button>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'SortingBar',
  props: {
    event: {
      type: Function,
    },
  },
  data() {
    return {
      sortItemsOpened: false,
    }
  },
  computed: {
    ...mapState({
      categorySort: (state) => state.category.sort,
      categoryViewMode: (state) => state.category.viewMode,
      filtersMobile: (state) => state.filtersMobile,
      perPage: (state) => state.category.perPage,
    }),
  },
  methods: {
    sortDisplayValue() {
      return this.$t(
        `sort.${this.categorySort ? this.categorySort : 'default'}`
      )
    },
    onToggleSelect() {
      this.sortItemsOpened = !this.sortItemsOpened
    },
    onSelect(v) {
      this.$store.commit('setCategorySort', v)
      this.sortItemsOpened = !this.sortItemsOpened
    },
    onSetViewMode(v) {
      this.$store.commit('setCategoryViewMode', v)
    },
    onOpenMobileFilters() {
      this.setFiltersMobile(!this.filtersMobile)
    },
    onSetPerpage(n) {
      this.setCategoryPerPage(n)
      this.setCategoryPage(1)
      this.$store.dispatch('resetScroll')
      this.event()
    },
    ...mapMutations([
      'setFiltersMobile',
      'setCategoryPerPage',
      'setCategoryPage',
    ]),
  },
  mounted() {
    this.setCategoryPerPage(12)
  },
}
</script>

<style>
.sort-wrapper {
  display: flex;
}
#sortarrow {
  position: absolute;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #000 transparent transparent transparent;
  margin-top: 8px;
  margin-left: 10px;
}
#sortarrow.active {
  border-color: transparent transparent #000 transparent;
  margin-top: 2px;
}
.viewmode {
  padding-left: 10px;
  padding-top: 10px;
}
.viewmode-icon {
  font-family: 'customicon';
  font-style: normal;
  font-weight: normal;
  speak: never;
  display: inline-block;
  text-decoration: none;
  width: 1.8em;
  margin-right: 0.6em;
  text-align: center;
  /* opacity: .8; */
  font-variant: normal;
  text-transform: none;
  line-height: 1.8em;
  margin-left: 0.6em;
  /* font-size: 120%; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
  color: gray;
  cursor: pointer;
}
.viewmode-icon:before {
  text-decoration: none;
}
.viewmode-icon.active {
  color: rgba(255, 67, 0, 0.9);
}
.perpage {
  padding-top: 11px;
  padding-left: 20px;
}
.perpage a {
  margin-left: 5px;
  margin-right: 5px;
}
.perpage a.active {
  font-weight: bold;
}
</style>
